import { createRoute } from '@/utils/routing'

export const CARD_ORDER_LIST_ROUTE = 'card-orders'
export const CARD_ORDER_VIEW_ROUTE = 'card-orders-orderId'
export const CARD_ORDER_EDIT_ROUTE = 'card-orders-orderId-edit'
export const CARD_ORDER_CREATE_ROUTE = 'card-orders-create'
export const CARD_LIST_ROUTE = 'cards'
export const CARD_VIEW_ROUTE = 'card-orders-orderId-card-data'
export const CARD_LIMITS_ROUTE = 'card-orders-orderId-card-limits'
export const CARD_DELIVERY_VIEW_ROUTE = 'card-orders-orderId-card-delivery'
export const CARD_ACTIVITY_LIST_ROUTE = 'card-orders-orderId-card-activity'

function createRouteWithOrderId (name, orderId, options) {
  if (orderId != null) {
    return createRoute(name, {
      params: { ...options.params, orderId },
      query: options.query
    })
  }
}

export function createCardOrderListRoute (options = {}) {
  return createRoute(CARD_ORDER_LIST_ROUTE, options)
}

export function createCardOrderViewRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_ORDER_VIEW_ROUTE, orderId, options)
}

export function createCardOrderEditRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_ORDER_EDIT_ROUTE, orderId, options)
}

export function createCardOrderCreateRoute (options = {}) {
  return createRoute(CARD_ORDER_CREATE_ROUTE, options)
}

export function createCardListRoute (options = {}) {
  return createRoute(CARD_LIST_ROUTE, options)
}

export function createCardViewRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_VIEW_ROUTE, orderId, options)
}

export function createCardDeliveryViewRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_DELIVERY_VIEW_ROUTE, orderId, options)
}

export function createCardActivityListRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_ACTIVITY_LIST_ROUTE, orderId, options)
}

export function createCardLimitsRoute (orderId, options = {}) {
  return createRouteWithOrderId(CARD_LIMITS_ROUTE, orderId, options)
}
